import { Injectable } from '@angular/core';
import { DataResponseHttp } from '../../../http-models/data-response.http';
import { DataResponseModel } from '../../../models/apis/data-response.model';
import { GetHospitalsPaginatedModel } from '../../../models/apis/system/hospital/get-hospitals-paginated.model';
import { BaseMapperWithSerializer } from '../../base.mapper';
import { HospitalQueryModel } from '../../../models/apis/system/hospital/hospital-query.model';
import { HospitalQueryHttp } from '../../../http-models/systems/hospital/hospital-query.http';
import { HospitalItemListModel } from '../../../models/apis/system/hospital/hospital-item-list.model';

@Injectable({
    providedIn: 'root',
})
export class GetHospitalsPaginatedMapper
    implements
    BaseMapperWithSerializer<
            GetHospitalsPaginatedModel,
            string,
            DataResponseModel<HospitalQueryModel>,
            DataResponseHttp<HospitalQueryHttp>
        >
{
    convertTo(model: GetHospitalsPaginatedModel): string {
        let request = `?PageIndex=${model.pageIndex}&PageSize=${model.pageSize}`;
        if(model.filter){
            request += `&Filter=${model.filter}`;
        }
        if(model.sortBy){
            request += `&SortBy=${model.sortBy}`;
        }
        if(model.sortOrder != null || model.sortOrder != undefined){
            request += `&SortOrder=${model.sortOrder}`;
        }
        if(model.hospitalIds && model.hospitalIds.length>0){
            model.hospitalIds.forEach(value => {
                request += `&HospitalIds=${value}`;
            });
        }
        request += `&IsActive=${model.isActive}`;
        return request;
    }

    convertFrom(
        http: DataResponseHttp<HospitalQueryHttp>
    ): DataResponseModel<HospitalQueryModel> {

        let response = {
            isError: http.isError,
            errors: http.errors
        } as DataResponseModel<HospitalQueryModel>;
        if(http.isError!=true && http.data){

            response.data = {
                pageIndex: http.data.pageIndex,
                pageSize: http.data.pageSize,
                totalPages: http.data.totalPages,
                totalRecords: http.data.totalRecords,
                isNextPageAvailable: http.data.isNextPageAvailable,
                sortBy: http.data.sortBy,
                sortOrder: http.data.sortOrder,
                isActive: http.data.isActive,
                hospitalIds: http.data.hospitalIds,
                hospitals: []
            } as HospitalQueryModel;

            for(let itemHttp of http.data.hospitals){
              let itemModel = {} as HospitalItemListModel;
              itemModel.id = itemHttp.id;
              itemModel.updatedBy = itemHttp.updatedBy;
              itemModel.updatedDateUtc = new Date(itemHttp.updatedDateUtc);
              itemModel.name = itemHttp.name;
              itemModel.code = itemHttp.code;
              itemModel.address1 = itemHttp.address1;
              itemModel.address2 = itemHttp.address2;
              itemModel.contactNumber = itemHttp.contactNumber;
              itemModel.isActive = itemHttp.isActive;
              itemModel.navbarBackgroundColor = itemHttp.navbarBackgroundColor ?? "#b32b23";
              itemModel.navbarForegroundColor = itemHttp.navbarForegroundColor ?? "#ffffff";

              response.data.hospitals.push(itemModel);
            }
        }
        return response;
    }
}
